import { render, staticRenderFns } from "./HxeChangguanDetails.vue?vue&type=template&id=b111c62e&scoped=true"
import script from "./HxeChangguanDetails.vue?vue&type=script&lang=js"
export * from "./HxeChangguanDetails.vue?vue&type=script&lang=js"
import style0 from "./HxeChangguanDetails.vue?vue&type=style&index=0&id=b111c62e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b111c62e",
  null
  
)

export default component.exports